import { format } from "date-fns";

export const addSystemTimeToDate=(dateString) =>{
    if (!dateString) return null; 

    const date = new Date(dateString); 
    console.log(date,"date");
    if (isNaN(date.getTime())) return null; 

    const now = new Date(); 
    

    
    date.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
    console.log(date,"now");

    return date.toISOString(); 
}

export const addProperSystemTimeToDate=(dateString) =>{
    if (!dateString) return null; 
    format(dateString,"yyyy-MM-dd")
    const date = new Date(dateString); 
    console.log(date,"date");
    if (isNaN(date.getTime())) return null; 

    const now = new Date(); 
    

    
    date.setHours(now.getHours(), now.getMinutes(), now.getSeconds(), now.getMilliseconds());
    console.log(date,"now");

    return date.toISOString(); 
}

